module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content view-home"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content section__copy"
  }, [_c('p', [_vm._v("Britain, Take A Bow is a generative artwork that sequences vignettes of British life, captured by a collaboration of filmmakers and artists across the UK, as we hurtle towards Brexit...")]), _vm._v(" "), _c('p', {
    staticClass: "mb-6"
  }, [_vm._v("Each 'play' is a unique experience - no two viewings will ever be the same")]), _vm._v(" "), _c('button', {
    staticClass: "button mr-2",
    on: {
      "click": _vm.goToVideo
    }
  }, [_vm._v("Play...")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'view-about'
      }
    }
  }, [_vm._v("About")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a947392c","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = 232
// module chunks = 1